// extracted by mini-css-extract-plugin
export default {"mycard1":"category_mycard1__75oZw","mycard2":"category_mycard2__lUsqm","mycard3":"category_mycard3__n6nZk","mycard4":"category_mycard4__9TyNg","mycard5":"category_mycard5__-K-xZ"};